/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Delete_Dialog_ToastInputs */

const en_ui_delete_dialog_toast = /** @type {(inputs: Ui_Delete_Dialog_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All data deleted`)
};

const de_ui_delete_dialog_toast = /** @type {(inputs: Ui_Delete_Dialog_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Daten gelöscht`)
};

/**
* | output |
* | --- |
* | "All data deleted" |
*
* @param {Ui_Delete_Dialog_ToastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_delete_dialog_toast = /** @type {((inputs?: Ui_Delete_Dialog_ToastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Delete_Dialog_ToastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_delete_dialog_toast(inputs)
	return de_ui_delete_dialog_toast(inputs)
});